import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import { AuthContext } from '@shared/context/AuthContext';
import TextInput from '@shared/component/TextInput';
import JoditEditor from 'jodit-react';
import { Button } from 'react-bootstrap';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';

export default function Setting() {
    const [tnc, setTnc] = useState(null);
    const [privacy, setPrivacy] = useState(null);
    const [contact, setContact] = useState(null);
    const [about, setAbout] = useState(null);
    const { setLoader } = useContext(AuthContext);
    const typeKey = {
        tnc: 1,
        pp: 2,
        contact: 3,
    };

    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/docs/,
        placeholder: 'Start typings...',
        height: 400,
        buttons: [
            'source',
            '|',
            'bold',
            'strikethrough',
            'underline',
            'italic',
            '|',
            'ul',
            'ol',
            '|',
            'outdent',
            'indent',
            '|',
            'font',
            'fontsize',
            'brush',
            'paragraph',
            '|',
            '|',
            'align',
            'undo',
            'redo',
            '|',
            'hr',
            'eraser',
            'copyformat',
            '|',
            'fullsize',
        ],
        buttonsXS: [
            'bold',
            'image',
            '|',
            'brush',
            'paragraph',
            '|',
            'align',
            '|',
            'undo',
            'redo',
            '|',
            'eraser',
            'dots',
        ],
    };

    useEffect(() => {
        getItem();
    }, []);

    const addItem = async () => {
        try {
            if (!contact) {
                Notify('error', 'Please enter contact number');
                return;
            }

            if (contact.length >= 11 || contact.length < 10) {
                Notify('error', 'Please enter 10 digit number');
                return;
            }
            const data = {
                values: JSON.stringify([
                    { title: 'Terms and conditions', type: 1, content: tnc },
                    { title: 'Privacy policy', type: 2, content: privacy },
                    { title: 'Contact', type: 3, content: contact },
                    { title: 'about', type: 4, content: about },
                ]),
            };

            setLoader(true);
            const { status } = await APIService.post('setting/', JSON.stringify(data), true, false);
            setLoader(false);
            if (status === 200) {
                Notify('success', 'Settings updated successfully');
                // setPrivacy(null);
                // setContact(null);
                // setTnc(null);
            }
        } catch (err) {
            setLoader(false);
        }
    };
    const getItem = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll('setting', true, false);
            setLoader(false);
            if (data.status === 200) {
                data?.data?.data.map(e => {
                    if (e.type === 1) {
                        setTnc(e.content);
                    } else if (e.type === 2) {
                        setPrivacy(e.content);
                    } else if (e.type === 3) {
                        setContact(e.content);
                    } else if (e.type === 4) {
                        setAbout(e.content);
                    }
                });
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const getValue = (e: any) => {
        try {
            // const data = { ...contact, ...e.target.value };

            setContact(e.contact);
        } catch (error) {}
    };

    return (
        <div className="container dash-container">
            <div className="dash_bread_box">
                <ul>
                    <li>Setting</li>
                </ul>
            </div>
            <div className="content_body_cover">
                <div style={{ marginTop: 10 }}>
                    <label style={{ marginBottom: 20 }}>Enter terms and conditions</label>
                    <JoditEditor
                        value={tnc}
                        config={config}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={newContent => setTnc(newContent)} // preferred to use only this option to update the content for performance reasons
                        // onChange={newContent => {
                        //     console.log(newContent);
                        // }}
                    />
                </div>
                <div style={{ marginTop: 40 }}>
                    <label style={{ marginBottom: 20 }}>Enter privacy policy</label>
                    <JoditEditor
                        value={privacy}
                        config={config}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={newContent => setPrivacy(newContent)} // preferred to use only this option to update the content for performance reasons
                        onChange={newContent => {}}
                    />
                </div>
                <div style={{ marginTop: 40 }}>
                    <label style={{ marginBottom: 20 }}>Enter about us</label>
                    <JoditEditor
                        value={about}
                        config={config}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={newContent => setAbout(newContent)} // preferred to use only this option to update the content for performance reasons
                        onChange={newContent => {}}
                    />
                </div>
                <div style={{ marginTop: 40 }}>
                    {/* <label style={{ marginBottom: 10 }}>Enter contact</label> */}
                    <div className="form-floating">
                        <div className="col-sm-4">
                            {/* <input
                            type="text"
                            style={{ width: '30%' }}
                            id="contact"
                            className="form-control"
                            placeholder="Enter contact information"
                            value={contact}
                            onChange={e => setContact(e.target.value)}
                        /> */}
                            <TextInput
                                data={{
                                    type: 'number',
                                    placeholder: 'Contact Number',
                                    name: 'contact',
                                    id: 'floatingInput',
                                }}
                                controlName="contact"
                                // isSubmit={isSubmit}
                                value={contact}
                                setValue={(e: any) => getValue(e)}
                                // errorMsg={errors?.weight.message}
                                // inputProps={errors}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: 35, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="default"
                        style={{ marginRight: 10 }}
                        className="btn custom_btn border_btn with_icon "
                        onClick={() => {
                            setTnc('');
                            setPrivacy('');
                            setContact('');
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        variant="secondary"
                        className="btn dark_btn custom_btn"
                        onClick={() => {
                            addItem();
                        }}
                    >
                        {'Save'}
                    </Button>
                </div>
            </div>
        </div>
    );
}
